<table class="container">
  <tbody>
    <tr>
      <td colspan="7" class="month-cell">
        <span [fiTranslation]="'_MONTH_' + shownMonth + '_SHORT'"></span> {{ shownYear }}

        <div class="buttons">
          <button [tabIndex]="unfocused ? -1 : 0" class="up" (click)="decrementMonth()">
            <img alt="Arrow up" src="/assets/icons/arrow-down-dark.svg">
            <span class="u-hidden-visually" fiTranslation="ALT_TEXT_CALENDAR_PREVIOUS_MONTH"></span>
          </button>
          <button [tabIndex]="unfocused ? -1 : 0" (click)="incrementMonth()">
            <img alt="Arrow down" src="/assets/icons/arrow-down-dark.svg">
            <span class="u-hidden-visually" fiTranslation="ALT_TEXT_CALENDAR_NEXT_MONTH"></span>
          </button>
        </div>
      </td>
    </tr>

    @for (week of days; track week; let i = $index) {
      @if (i === 1) {
        <tr>
          @for (day of week; track day; let weekDayIndex = $index) {
            <td class="week-day-cell">
              <span [fiTranslation]="'_WEEK_DAY_' + weekDayIndex + '_SHORT'"></span>
            </td>
          }
        </tr>
      }
    }

    @for (week of days; track week) {
      <tr>
        @for (currentDay of week; track currentDay) {
          <td>
            @if (currentDay) {
              <button
                [tabIndex]="unfocused ? -1 : 0"
                class="day-button"
                [class.today]="isToday(currentDay)"
                [class.range-start]="isRangeStart(currentDay)"
                [class.range-end]="isRangeEnd(currentDay)"
                [class.in-range]="isInRange(currentDay)"
                [class.selected]="isRangeStart(currentDay) || isRangeEnd(currentDay)"
                (click)="selectDay(currentDay)"
                >
                {{ currentDay.getDate() }}
              </button>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
